$(function(){
    $('#shopify-section-template--19384520769715__176016651422c48f40').addClass('active');
    $('.iwish-faq-container .faq-title-container').on('click',function(){
        let d = $(this).next('.faq-content').css('display');
        if (!d || d == 'none') {
            $(this).addClass('active');
            $(this).next('.faq-content').slideDown(200);
        } else {
            $(this).removeClass('active');
            $(this).next('.faq-content').slideUp(200);
        }
    });

    $('.iwish-tab-container .tab-head').on('click',function(){
        let id = $(this).attr('data');
        $('.iwish-tab-container .tab-head').removeClass('active');
        $(this).addClass('active');
        let s_id = [
            'shopify-section-template--19384520769715__176016651422c48f40',
            'shopify-section-template--19384520769715__176016652825356a9b',
            'shopify-section-template--19384520769715__17602466288dff597e',
            'shopify-section-template--19384520769715__1760248289deb9efd7'
        ];

        $.each(s_id,function(i,v){
            // console.log(id);
            if(id == v){
                $('#'+v).addClass('active');
            }else{
                $('#'+v).removeClass('active');
            }
            
        });
    });
});